module.exports = __webpack_public_path__ + "static/img/car_4.48e83d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car_4.png
// module id = wOE/
// module chunks = 1